import {langRegister} from "./langRegister";
import {salesChannelRegister} from "./salesChannelRegister";

class marketRegister {

    static default_market = "ae";

    static market = false;

    static available_markets = [
        {code: "se", name: langRegister.lang() === "sv" ? "Sverige" : "Sweden"},
        {code: "ae", name: langRegister.lang() === "sv" ? "UAE" : "UAE"}
    ];

    static sales_channel_market = {
        code: "",
        currency: "",
        vat: 0,
        channels: [],
        country_region: {},
        default_language: "",
    };

    static markets = {
        se: {
            code: "se",
            name: langRegister.lang() === "sv" ? "Sverige" : "Sweden",
            languages: [
                {code: "en", name: "English"},
                {code: "sv", name: "Svenska"}
            ],
            default_language: "sv",
            ad_language: langRegister.lang() === "sv" ? "Svenska" : "Swedish",
            currency: "SEK",
            vat: 25,
            channels: ["facebook", "instagram", "google", "bing"],
            country: {id: 1, name: langRegister.lang() === "sv" ? "Sverige" : "Sweden"},
            min_budget: 500,
            lower_min_budget: 100,
            low_plan: {
                type: "low",
                title: {en: "Basic plan", sv: "Standardplan"},
                short_title: langRegister.lang() === "sv" ? "Standard" : "Basic",
                price: 100,
                items: [
                    {title: langRegister.lang() === "sv" ? "2 kanaler" : "2 channels"},
                    {title: langRegister.lang() === "sv" ? "1 område" : "1 location"},
                    {title: langRegister.lang() === "sv" ? "Standard filtrering" : "Basic filtering"},
                    {title: langRegister.lang() === "sv" ? "Gratis landningssida" : "Free landing page"},
                    {title: langRegister.lang() === "sv" ? "Standard support" : "Basic support"}
                ]
            },
            high_plan: {
                type: "high",
                title: {en: "Basic plan", sv: "Standardplan"},
                short_title: langRegister.lang() === "sv" ? "Standard" : "Basic",
                price: 200,
                items: [
                    {title: langRegister.lang() === "sv" ? "Obegränsade kanaler" : "Unlimited channels"},
                    {title: langRegister.lang() === "sv" ? "Obegränsade områden" : "Unlimited locations"},
                    {title: langRegister.lang() === "sv" ? "Avancerad filtrering" : "Advanced filtering"},
                    {title: langRegister.lang() === "sv" ? "Gratis landningssida" : "Free landing page"},
                    {title: langRegister.lang() === "sv" ? "Standard support" : "Basic support"}
                ]
            },
            master_plan: {
                title: langRegister.lang() === "sv" ? "Återförsäljare plan" : "Reseller plan",
                short_title: langRegister.lang() === "sv" ? "Återförsäljare" : "Reseller",
                price: 500,
                items: [
                    {title: langRegister.lang() === "sv" ? "Obegränsade kanaler" : "Unlimited channels"},
                    {title: langRegister.lang() === "sv" ? "Obegränsade områden" : "Unlimited locations"},
                    {title: langRegister.lang() === "sv" ? "Avancerad filtrering" : "Advanced filtering"},
                    {title: langRegister.lang() === "sv" ? "Avancerad anpassning" : "Advanced tweaking"},
                    {title: langRegister.lang() === "sv" ? "Prioritetssupport" : "Priority support"}
                ]
            },
            discount: 2,
            lockin: 12,
            title: "adBop | Annonsera online helt enkelt",
            trending_industries: [
                {id: 10406, name: langRegister.lang() === "sv" ? "Hemstädning" : "House cleaning"},
                {id: 12436, name: langRegister.lang() === "sv" ? "Biltvätt" : "Car wash"},
                {id: 14025, name: langRegister.lang() === "sv" ? "Rörmokare" :  "Plumbing"},
                {id: 11551, name: langRegister.lang() === "sv" ? "Tvätt" : "Laundry"},
                {id: 11505, name: langRegister.lang() === "sv" ? "Kemtvätt" : "Dry cleaning"}
            ]
        },
        ae: {
            code: "ae",
            name: "UAE",
            languages: [
                {code: "en", name: "English"},
            ],
            ad_language: "English",
            default_language: "en",
            currency: "AED",
            vat: 0,
            channels: ["facebook", "instagram", "google", "bing"],
            country: {id: 4940, name: "UAE"},
            min_budget: 200,
            lower_min_budget: 50,
            low_plan: {
                type: "low",
                title: "Basic plan",
                short_title: langRegister.lang() === "sv" ? "Standard" : "Basic",
                price: 50,
                items: [
                    {title: "2 channels"},
                    {title: "1 location"},
                    {title: "Basic filtering"},
                    {title: "Free landing page"},
                    {title: "Basic support"}
                ]
            },
            high_plan: {
                type: "high",
                title: "Basic plan",
                short_title: langRegister.lang() === "sv" ? "Standard" : "Basic",
                price: 100,
                items: [
                    {title: "Unlimited channels"},
                    {title: "Unlimited locations"},
                    {title: "Advanced filtering"},
                    {title: "Free landing page"},
                    {title: "Basic support"}
                ]
            },
            master_plan: {
                title: "Reseller plan",
                short_title: langRegister.lang() === "sv" ? "Återförsäljare" : "Reseller",
                price: 250,
                items: [
                    {title: "Unlimited channels"},
                    {title: "Unlimited locations"},
                    {title: "Advanced filtering"},
                    {title: "Advanced tweaking"},
                    {title: "Priority support"}
                ]
            },
            discount: 2,
            lockin: 12,
            title: "adBop | Online ads made simple",
            trending_industries: [
                {id: 16568, name: "House cleaning"},
                {id: 17270, name: "Car wash"},
                {id: 17384, name: "Plumbing"},
                {id: 17077, name: "Laundry"},
                {id: 17089, name: "Dry cleaning"}
            ]
        }
    };

    static setMarket(market, lang) {
        marketRegister.market = market;
        if(lang){
            langRegister.set(lang);
        }
        try {
            sessionStorage.setItem("market", market);
        } catch (error) {}
    }

    static getMarket() {
        try {
            let market = salesChannelRegister.get("market");
            if (market) {
                return marketRegister.markets[market];
            } else {
                return marketRegister.markets[marketRegister.default_market];
            }
        } catch (error) {
            return marketRegister.markets[marketRegister.default_market];
        }
    }

    static getMarketValue(option) {
        try {
            let market = salesChannelRegister.get("market");
            if (market) {
                return marketRegister.markets[market][option];
            } else {
                return marketRegister.markets[marketRegister.default_market][option];
            }
        } catch (error) {
            return marketRegister.markets[marketRegister.default_market][option];
        }
    }

    //SHORTENER
    static set(market) {
        marketRegister.setMarket(market);
    }

    static get() {
        return marketRegister.getMarket();
    }

    static allMarkets() {
        return marketRegister.available_markets;
    }

    static marketName() {
        return marketRegister.getMarketValue("name");
    }

    static code() {
        return marketRegister.getMarketValue("code");
    }

    static currency() {
        return marketRegister.getMarketValue("currency");
    }

    static vat() {
        return marketRegister.getMarketValue("vat");
    }

    static defaultLang() {
        return marketRegister.getMarketValue("default_language");
    }

    static country() {
        return marketRegister.getMarketValue("country");
    }

    static countryCode() {
        let country = marketRegister.getMarketValue("country");
        return country.id;
    }

    static languages() {
        return marketRegister.getMarketValue("languages");
    }

    static lowPlan() {
        return marketRegister.getMarketValue("low_plan");
    }

    static highPlan() {
        return marketRegister.getMarketValue("high_plan");
    }

    static masterPlan() {
        return marketRegister.getMarketValue("master_plan");
    }

    static minBudget() {
        return marketRegister.getMarketValue("min_budget");
    }

    static lowerMinBudget() {
        return marketRegister.getMarketValue("lower_min_budget");
    }

    static adLanguage() {
        return marketRegister.getMarketValue("ad_language");
    }

    static discount() {
        return marketRegister.getMarketValue("discount");
    }

    static lockin() {
        return marketRegister.getMarketValue("lockin");
    }

    static title() {
        return marketRegister.getMarketValue("title");
    }

    static trending() {
        return marketRegister.getMarketValue("trending_industries");
    }

}

export {marketRegister}


// WEBPACK FOOTER //
// ./src/services/marketRegister.js